<section class="clients_section">
  <div class="clients__container">
    <div class="clients__data">
      <h1 class="section__title">Nuestros Clientes</h1>
      <p class="section__subtitle">
        Empresas que confían en Corvus TID para sus soluciones tecnológicas
      </p>

      <div class="clients__grid">
        <div class="client__card" *ngFor="let client of clients">
          <div class="client__logo-container">
            <img 
              [src]="client.logo" 
              [alt]="client.name + ' logo'"
              class="client__logo"
              (error)="onImageError($event)"
            >
          </div>
          <div class="client__info">
            <h3 class="client__name">{{ client.name }}</h3>
            <p class="client__description" *ngIf="client.description">
              {{ client.description }}
            </p>
            <a 
              *ngIf="client.website" 
              [href]="client.website" 
              target="_blank" 
              rel="noopener noreferrer"
              class="client__link"
            >
              Visitar sitio web
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
